<template>
  <div>
    <div class="p-6 pb-0">
      <BreadCrumbs :navigation="navigation" />
      <div class="flex items-center pt-6">
        <button @click="openAddBadgeModal" class="bg-blue-500 text-white px-4 py-2 rounded-md shadow-md">Aggiungi Badge</button>
      </div>
    </div>
    <div class="p-6 pb-0">
      <PageServerTable
        :headers="headers"
        :items="badges"
        :items-per-page.sync="ipp"
        :items-per-page-options="ippo"
        :sort-by="sortby"
        :items-length="badgesCount"
        :reload-fn="reload"
        :item-value="'id'"
        :page="page"
        show-current-page
      >
        <template #item.validSince="{ item }">
          <span>{{ item.validSince ? formatDate(item.validSince) : '-' }}</span>
        </template>
        <template #item.validUntil="{ item }">
          <span>{{ item.validUntil ? formatDate(item.validUntil) : '-' }}</span>
        </template>
        <template #item.actions="{ item }">
          <button @click="openEditBadgeModal(item)" class="bg-yellow-500 text-white px-2 py-1 rounded-md mr-2">Modifica</button>
          <button @click="openDeleteBadgeModal(item)" class="bg-red-500 text-white px-2 py-1 rounded-md">Elimina</button>
        </template>
      </PageServerTable>
    </div>

    <!-- Modale per aggiungere/modificare badge -->
    <div v-if="showBadgeModal" class="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50" @mousedown="closeBadgeModal">
      <div class="bg-white p-6 rounded-md w-full max-w-md" @mousedown.stop>
        <h2 class="text-xl mb-4">{{ isEditing ? 'Modifica' : 'Aggiungi' }} badge</h2>
        <form @submit.prevent="isEditing ? updateBadge() : addBadge()">
          <div class="mb-4">
            <label class="block text-gray-700">Codice</label>
            <input v-model="badgeForm.code" type="text" class="p93__input" required>
            <div v-if="badgeForm.errors.code" class="text-red-500 text-sm pt-2">{{ badgeForm.errors.code }}</div>
          </div>
          <div class="mb-4">
            <label class="block text-gray-700">Inizio validità</label>
            <Datepicker v-model="badgeForm.validSince" :format="dateFormat" class="p93__input" :clearable="true" />
            <div v-if="badgeForm.errors.validSince" class="text-red-500 text-sm">{{ badgeForm.errors.validSince }}</div>
          </div>
          <div class="mb-4">
            <label class="block text-gray-700">Fine validità</label>
            <Datepicker v-model="badgeForm.validUntil" :format="dateFormat" class="p93__input" :clearable="true" />
            <div v-if="badgeForm.errors.validUntil" class="text-red-500 text-sm">{{ badgeForm.errors.validUntil }}</div>
          </div>
          <div class="flex justify-end">
            <button type="button" @click="closeBadgeModal" class="bg-gray-500 text-white px-4 py-2 rounded-md mr-2">Annulla</button>
            <button type="submit" class="bg-blue-500 text-white px-4 py-2 rounded-md">{{ isEditing ? 'Aggiorna' : 'Aggiungi' }}</button>
          </div>
          <input type="hidden" v-model="badgeForm.id">
        </form>
      </div>
    </div>

    <!-- Modale di conferma eliminazione -->
    <div v-if="showDeleteModal" class="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50" @click="closeDeleteBadgeModal">
      <div class="bg-white p-6 rounded-md w-full max-w-md" @click.stop>
        <h2 class="text-xl mb-4">Conferma Eliminazione</h2>
        <p>Sei sicuro di voler eliminare il badge {{ badgeToDelete.code }}?</p>
        <div class="flex justify-end mt-4">
          <button @click="closeDeleteBadgeModal" class="bg-gray-500 text-white px-4 py-2 rounded-md mr-2">Annulla</button>
          <button @click="deleteBadge" class="bg-red-500 text-white px-4 py-2 rounded-md">Elimina</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Link, useForm, router } from '@inertiajs/vue3';
import BreadCrumbs from '@/Components/BreadCrumbs.vue';
import Datepicker from 'vue3-datepicker';
import PageServerTable from '@/Components/PageServerTable.vue';
import { format } from 'date-fns';

export default {
  props: ['badges', 'badgesCount', 'errors'],
  components: {
    Link,
    BreadCrumbs,
    Datepicker,
    PageServerTable
  },
  data() {
    return {
      headers: [],
      sortby: [],
      ipp: 5,
      ippo: [
        { value: 5, title: '5' },
        { value: 10, title: '10' },
        { value: 25, title: '25' },
        { value: 50, title: '50' }
      ],
      page: 1,
      showBadgeModal: false,
      showDeleteModal: false,
      isEditing: false,
      badgeForm: useForm({
        id: null,
        code: '',
        validSince: '',
        validUntil: ''
      }),
      badgeToDelete: null,
      navigation: [
        { name: 'Dashboard', href: route('dashboard') },
        { name: this.$t('modules.reception-digitale'), href: route('modules.home', 'reception-digitale') },
        { name: 'Badge', href: route('modules.rd-gestione-badge') }
      ],
      dateFormat: 'yyyy-MM-dd'
    };
  },
  mounted() {
    this.headers = this.$attrs.headers;
    this.sortby = this.$attrs.sortby;
    this.ipp = this.$attrs.ipp;
    this.page = this.$attrs.page;
  },
  methods: {
    reload(sortby = undefined, itemsperpage = undefined, page = undefined) {
      if (sortby) this.sortby = sortby;
      if (itemsperpage) this.ipp = itemsperpage;
      if (page) this.page = page;
      router.post(window.location.href, {
        headers: this.headers,
        sortby: this.sortby,
        itemsperpage: this.ipp,
        page: this.page
      }, { only: ['badges', 'badgesCount'] });
    },
    formatDate(date) {
      return format(new Date(date), 'dd/MM/yyyy');
    },
    openAddBadgeModal() {
      this.badgeForm.clearErrors();
      this.badgeForm.id = null;
      this.badgeForm.code = null;
      this.badgeForm.validSince = null;
      this.badgeForm.validUntil = null;
      this.isEditing = false;
      this.showBadgeModal = true;
    },
    openEditBadgeModal(badge) {
      this.badgeForm.reset();
      this.badgeForm.id = badge.id;
      this.badgeForm.code = badge.code;
      this.badgeForm.validSince = (badge.validSince) ? new Date(badge.validSince) : null;
      this.badgeForm.validUntil = (badge.validUntil) ? new Date(badge.validUntil) : null;
      this.isEditing = true;
      this.showBadgeModal = true;
    },
    closeBadgeModal() {
      this.showBadgeModal = false;
    },
    addBadge() {
      this.badgeForm.post(route('modules.rd-aggiungi-badge'), {
        onSuccess: () => this.closeBadgeModal()
      });
    },
    updateBadge() {
      this.badgeForm.post(route('modules.rd-modifica-badge'), {
        onSuccess: () => this.closeBadgeModal()
      });
    },
    openDeleteBadgeModal(badge) {
      this.badgeToDelete = badge;
      this.showDeleteModal = true;
    },
    closeDeleteBadgeModal() {
      this.showDeleteModal = false;
    },
    deleteBadge() {
      this.badgeForm.delete(route('modules.rd-elimina-badge', this.badgeToDelete.id), {
        onSuccess: () => this.closeDeleteBadgeModal()
      });
    }
  }
};
</script>